<template>
  <div class="menu_bottom">
    <div class="menu_bottom_container">
      <div class="login_user_name">
        <label class="login_user_name_label">{{ accountName }}</label>
      </div>
      <div class="menu_bottom_icons">
        <img
          :src="option"
          class="option"
          @click="showChangePasswordModal = true"
        />
        <img :src="escape" class="escape" @click="showExitModalWindow = true" />
      </div>
      <div class="modal_window" v-if="showExitModalWindow">
        <exitModalWindow :question="logoutWord" @close="close" @ok="logout">
        </exitModalWindow>
      </div>
      <div class="modal_window" v-if="showChangePasswordModal">
        <changePasswordModalWindow :mode="mode" @close="close" @change="change">
        </changePasswordModalWindow>
      </div>
      <div class="modal_window" v-if="showfailedModal">
        <failedModalWindow :question="failedWord" @close="close">
        </failedModalWindow>
      </div>
      <div class="loading_modal_window" v-if="showloadingModal">
        <loadingModalWindow @close="close"> </loadingModalWindow>
      </div>
    </div>
  </div>
</template>

<script>
import exitModalWindow from './modalWindow/confirmModalWindow.vue'
import failedModalWindow from './modalWindow/finishModalWindow.vue'
import loadingModalWindow from '../../modalWindow/loadingModalWindow.vue'
import changePasswordModalWindow from './modalWindow/changePasswordModalWindow.vue'

export default {
  data() {
    return {
      option: require('../../../img/option.png'),
      escape: require('../../../img/escape.png'),
      logoutWord: 'ログアウトしますか？',
      failedWord: '',
      mode: 'master',
      showExitModalWindow: false,
      showChangePasswordModal: false,
      showfailedModal: false,
      showloadingModal: false,
      accountName: ''
    }
  },
  components: {
    changePasswordModalWindow,
    exitModalWindow,
    failedModalWindow,
    loadingModalWindow
  },
  computed: {
    sysErrorMsg() {
      return this.$store.state.error.sysErrorMsg
    }
  },
  methods: {
    close(e) {
      this.showExitModalWindow = false
      this.showfailedModal = false
      this.showChangePasswordModal = false
      this.showloadingModal = false
    },
    async logout(e) {
      this.showloadingModal = true
      try {
        await this.$store.dispatch('masterSessions/logoutCareRings')
        await this.$store.dispatch('systemAdminDefine/successLogoutFlag')
      } catch (error) {}
      this.$router.push('/Master/Pages')
      this.close()
    }
  }
}
</script>
<style scoped>
.menu_bottom {
  background-color: #bbffff;
}
</style>



// WEBPACK FOOTER //
// src/components/masterPanel/masterView/menubottom.vue